import React, { useState, useContext, useEffect } from "react";
import { Stack, Typography, Button, Box } from "@mui/material";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
//Icons
import BorderColorIcon from "@mui/icons-material/BorderColor";
//Srcs
import "./studentdetails.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import StudentPayment from "./StudentPayment/StudentPayment";
import StudentInfo from "./StudentInfo";
import StudentEnrollment from "./StudentEnrollment";
import ParentsInfo from "./ParentsInfo";
import { GET_STUDENT_BY_ID } from "../../Schema/Student";
import GuardianInfo from "./GuardianInfo";

export default function StudentDetails() {
  // change language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  // =================== get studentId from url =======================
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [studentId, setStudentId] = useState(params.get("studentId"));

  let tabNameFromLocal = JSON.parse(
    window.localStorage.getItem("tabNameFromLocal")
  );
  const [tabName, setTabName] = useState(
    tabNameFromLocal ? tabNameFromLocal : "payment"
  );
  const [detailsData, setDetailsData] = useState();

  const { refetch } = useQuery(GET_STUDENT_BY_ID, {
    variables: {
      id: studentId,
    },
    onCompleted: ({ getStudentById }) => {
      // console.log("getStudentById", getStudentById)
      setDetailsData(getStudentById);
    },
    onError: (err) => {
      console.log("err::", err.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [studentId]);

  const handleTabInfo = (e) => {
    setTabName(e);
    window.localStorage.setItem("tabNameFromLocal", JSON.stringify(e));
  };
  const handleTabEnrollment = (e) => {
    setTabName(e);
    window.localStorage.setItem("tabNameFromLocal", JSON.stringify(e));
  };
  const handleTabParents = (e) => {
    setTabName(e);
    window.localStorage.setItem("tabNameFromLocal", JSON.stringify(e));
  };
  const handleTabGuandians = (e) => {
    setTabName(e);
    window.localStorage.setItem("tabNameFromLocal", JSON.stringify(e));
  };
  const handleTabPayment = (e) => {
    setTabName(e);
    window.localStorage.setItem("tabNameFromLocal", JSON.stringify(e));
  };

  return (
    <div className="student-details">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/student">
            <Typography className="page-title">Students</Typography>
          </Link>
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">
            {detailsData?.englishName}
          </Typography>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">Students</Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box className="tabs-containner">
        <Box className="box-container">
          <Stack direction="row">
            <Button
              onClick={() => handleTabPayment("payment")}
              className={tabName === "payment" ? "active-btn-tabs" : "btn-tabs"}
            >
              Payment
            </Button>

            <Button
              onClick={() => handleTabInfo("information")}
              className={
                tabName === "information" ? "active-btn-tabs" : "btn-tabs"
              }
            >
              Information
            </Button>

            <Button
              onClick={() => handleTabParents("parents-info")}
              className={
                tabName === "parents-info" ? "active-btn-tabs" : "btn-tabs"
              }
            >
              Parents Info
            </Button>
            <Button
              onClick={() => handleTabGuandians("guardian-info")}
              className={
                tabName === "guardian-info" ? "active-btn-tabs" : "btn-tabs"
              }
            >
              Guardian Info
            </Button>
            <Button
              onClick={() => handleTabEnrollment("enrollment")}
              className={
                tabName === "enrollment" ? "active-btn-tabs" : "btn-tabs"
              }
            >
              Enrollment
            </Button>

            <Box sx={{ flexGrow: 1 }} />

            <Stack direction="row" spacing={2} sx={{ height: "40px" }}>
              {/* {tabName === "payment" ? (
                <Button className="btn-create">Create Invoice</Button>
              ) : null} */}
            </Stack>
          </Stack>
        </Box>
        <Box>
          {tabName === "payment" ? (
            <StudentPayment detailsData={detailsData} />
          ) : tabName === "information" ? (
            <StudentInfo detailsData={detailsData} />
          ) : tabName === "parents-info" ? (
            <ParentsInfo detailsData={detailsData} />
          ) : tabName === "enrollment" ? (
            <StudentEnrollment detailsData={detailsData} />
          ) : tabName === "guardian-info" ? (
            <GuardianInfo detailsData={detailsData} />
          ) : null}
        </Box>
      </Box>
    </div>
  );
}
